<!--
 * @Author: cryi.liu
 * @Date: 2020-05-15 14:53:22
 * @LastEditTime: 2020-06-20 17:05:54
 * @Description: 单选或判断作答区域
-->
<template>
  <div class="single-choice">
    <div class="single-choice-item-wrapper"
      v-for="(option, index) in options"
      :key="option.id">
      <div
        class="single-choice-item"
        :class="answer === option.id ? 'active' : ''"
        @click="clickOption(option)">
        <span>
          <span class="prefix">{{ optionsEnum[index] }}</span>
          <span
            v-if="computeOptionType(option) === 'text'
            || computeOptionType(option) === 'hybrid'">{{ option.content }}</span>
          <template v-if="computeOptionType(option) === 'media'">
            <video-player
              v-if="computeMediaType(option) === 'mp4'"
              :media-path="option.mediaInfoVO.mediaPath"
              :video-cover="option.mediaInfoVO.videoCover" />
            <audio-player
              v-if="computeMediaType(option) === 'mp3'"
              :media-path="option.mediaInfoVO.mediaPath" />
            <image-player
              v-if="computeMediaType(option) === 'jpg'"
              :media-path="option.mediaInfoVO.mediaPath" />
            <div
              v-else-if="computeMediaType(option) === 'pdf'"
              class="look-media"
              @click.stop="lookMedia(
                option.mediaPath,
                option.mediaInfoVO.mediaPath,
                option.mediaInfoVO.videoCover
              )">查看pdf多媒体文件</div>
          </template>
        </span>
        <img class="suffix" src="../../../../../assets/image/checked.png" />

        <div
          v-if="computeOptionType(option) === 'hybrid'"
          class="look-media"
          @click.stop="lookMedia(
            option.mediaPath,
            option.mediaInfoVO.mediaPath,
            option.mediaInfoVO.videoCover
            )">查看多媒体</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from '../../../../../utils';
import VideoPlayer from './VideoPlayer.vue';
import AudioPlayer from './AudioPlayer.vue';
import ImagePlayer from './ImagePlayer.vue';

const optionsEnum = ['A', 'B', 'C', 'D', 'E', 'F'];

export default {
  name: 'SingleChoice',
  components: {
    VideoPlayer,
    AudioPlayer,
    ImagePlayer,
  },
  props: {
    type: { type: String, required: true },
    index: { type: Number, required: true },
    timeRemaining: { type: String, required: true },
  },
  data() {
    return {
      optionsEnum,
      answer: '',
    };
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'onlineExamStore/libraryInfo',
    }),
    question() {
      return this.libraryInfo[this.index];
    },
    options() {
      return this.question.libraryVo.options;
    },
  },
  watch: {
    question: {
      immediate: true,
      handler(question) {
        if (question.answer) {
          this.answer = question.answer;
        } else {
          this.answer = '';
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setLibraryInfo: 'onlineExamStore/invokeSetLibraryInfo',
    }),
    clickOption({ id }) {
      this.answer = id;
      this.requestSaveAnswerAndSetting(id);
    },
    lookPdfMedia(mediaPath) {
      window.open(mediaPath, '_blank');
    },
    lookMedia(mediaPath, realMediaPath, videoCover) {
      this.$emit('preview-media', { mediaPath, realMediaPath, videoCover });
    },
    /**
     * 计算选项类型 -> 纯文本(text)/纯多媒体(media)/混合(hybrid)
     */
    computeOptionType(option) {
      if (option.content && option.mediaPath) {
        return 'hybrid';
      }

      if (option.content) {
        return 'text';
      }

      if (option.mediaPath) {
        return 'media';
      }

      return '';
    },
    computeMediaType({ mediaPath }) {
      const jpgReg = /jpg/;
      const pdfReg = /pdf/;
      const mp4Reg = /mp4/;
      const mp3Reg = /mp3/;

      if (jpgReg.test(mediaPath)) {
        return 'jpg';
      }

      if (mp4Reg.test(mediaPath)) {
        return 'mp4';
      }

      if (mp3Reg.test(mediaPath)) {
        return 'mp3';
      }

      if (pdfReg.test(mediaPath)) {
        return 'pdf';
      }

      return '';
    },
    /**
     * 单项选择发生改变
     */
    async singleChoiceSlectChanged(answer) {
      this.requestSaveAnswerAndSetting(answer);
    },
    /**
     * 请求保存答题信息并设置
     */
    requestSaveAnswerAndSetting: debounce(function (answer) {
      this.requestSaveAnswer(answer)
        .then(() => {
          const libraryInfo = JSON.parse(JSON.stringify(this.libraryInfo));

          libraryInfo[this.index].answer = answer;

          this.setLibraryInfo({ libraryInfo });
        })
        .catch((result) => {
          alert(result.msg);

          if (result.msg === '您已在另一终端进入考试') {
            window.open('/mvc/page?loc=portal/gate&locale=zh&skipRefer=1', '_self');
          }
        });
    }, 500),
    /**
     * 请求保存答题信息
     */
    requestSaveAnswer(answer) {
      const params = {
        id: this.question.id,
        answer,
        remainingTime: this.timeRemaining,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.answer.saveAnswer(params);
        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.single-choice {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 12px;
  width: 100%;

  .single-choice-item-wrapper {
    flex: 0 0 calc(50% - 40px);
    margin-right: 40px;
    margin-bottom: 20px;
  }

  &-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 0 0 50%;
    width: 80%;
    max-width: 460px;
    margin-bottom: 12px;
    padding: 8px 12px;
    background-color: #F1F1F1;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;

    .look-media {
      display: inline-block;
      color: #0C8CCA;
      font-size: 12px;
      cursor: pointer;
      padding: 4px 8px;
      background-color: rgba(12, 140, 202, .1);
      border-radius: 6px;
    }

    > span {
      flex: 1;
    }

    &.active {
      background-color: rgba(12, 140, 202, 0.08);
      color: #0C8CCA;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 1.2px solid #0C8CCA;
        border-radius: 4px;
        pointer-events: none;
      }

      > .suffix {
        display: block;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    > span:first-of-type {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .prefix {
      margin-right: 12px;
      font-weight: bold;
    }

    > .suffix {
      margin-left: 12px;
      width: 14px;
      height: 14px;
      display: none;
    }

    > .look-media {
      position: absolute;
      right: -12px;
      top: 50%;
      z-index: 300;
      transform: translateX(100%) translateY(-50%);
      color: #0C8CCA;
      font-size: 12px;
      cursor: pointer;
      padding: 4px 8px;
      background-color: rgba(12, 140, 202, .1);
      border-radius: 6px;
    }
  }

  // /deep/ .ivu-radio-group {
  //   .ivu-radio-wrapper {
  //     font-size: 12px;

  //     .ivu-radio {
  //       margin-right: 8px;
  //     }

  //     .ivu-radio-disabled .ivu-radio-inner:after {
  //       background-color: #2d8cf0;
  //     }
  //   }
  // }
}
</style>
